import {Injectable} from '@angular/core';
import {Dropbox, DropboxAuth} from 'dropbox';
import {Path} from '../../shared/path';
import {Observable} from 'rxjs';
import {IdexService} from '../../idex.service';

declare const client_id_dropbox: string;
declare const appSecret_dropbox: string;


@Injectable()
export class DropBox {
   private openPopup: any;
   private clientId = client_id_dropbox;
   private clientSecret= appSecret_dropbox;
   redirectUri: any = Path.getAppUrl('callback-dropbox');
   private urlAunth = 'https://www.dropbox.com/oauth2/authorize?client_id='+this.clientId+'&redirect_uri='+this.redirectUri+'&response_type=token'
   private checkUserurlLogin = 'https://www.dropbox.com/static/api/2/dropins.js'
   private keyAccessToken: any;
   private refreshAccessToken;
   private authToken = new DropboxAuth({
      clientId: this.clientId,
      clientSecret: this.clientSecret,
      accessToken: localStorage.getItem('access_token_dropbox')
   });

   constructor(private service: IdexService) {}

   signIn() {
      this.popup(this.urlAunth);
      this.codeTokenChallenge();
   }

   getDropbox(){
      return new Observable<any>(observer => {
         this.keyAccessToken = localStorage.getItem('access_token_dropbox');
         if (this.keyAccessToken) {
            const dbx = new Dropbox({
               accessToken: this.keyAccessToken
            });
            dbx.usersGetCurrentAccount()
               .then(function (response) {
                  observer.next(response.result);
               })
               .catch(function (error) {
                  console.error(error);
                  throw new Error(error);
               });
         }
      });
   }

   getDropboxPage() {
      return new Observable<any>(observer => {
         const code = localStorage.getItem('dropbox_auth');
         if (code) {
            this.service.dropBoxAuthToken(code,this.redirectUri).subscribe((res) => {
                  localStorage.setItem('access_token_dropbox', res.accessToken);
                  localStorage.setItem('refresh_token_dropbox', res.refreshToken);
                  observer.next(res);
               },
               (err) => {
                  console.error(err);
               });
            }
      });
   }

   getAccountProfile(){// for get all profile dropbox with access_token
      this.keyAccessToken = localStorage.getItem('access_token_dropbox');
      this.refreshAccessToken = localStorage.getItem('refresh_token_dropbox');
      const dbx = new Dropbox({
         clientId: this.clientId,
         clientSecret: this.clientSecret,
         accessToken: this.keyAccessToken,
         refreshToken: this.refreshAccessToken
      });
      dbx.usersGetCurrentAccount()
         .then(function (response) {
            return response;
         })
         .catch(function (error) {
            console.error(error);
            throw new Error(error);
         });
   }

   codeTokenChallenge(){
      this.authToken.getAuthenticationUrl(this.redirectUri, '', 'code', 'offline', [
            'files.content.write',
            'files.content.read',
         ], 'user',
         true).then(function (response) {
         const codeKey = response.split('&')[7].replace('code_challenge=', '');
         localStorage.setItem('code_key_dropbox', codeKey);
      }).catch(function (error) {
         console.error(error);
         throw new Error(error);
      });
   }

   popup(url: any) {
      const width = 650,
         height = 650,
         screenX = window.screenX,
         screenY = window.screenY,
         outerWidth = window.outerWidth,
         outerHeight = window.outerHeight;

      const left = screenX + Math.max(outerWidth - width, 0) / 2;
      const top = screenY + Math.max(outerHeight - height, 0) / 2;

      const features = [
         'width=' + width,
         'height=' + height,
         'top=' + top,
         'left=' + left,
         'status=no',
         'resizable=yes',
         'toolbar=no',
         'menubar=no',
         'scrollbars=yes'];
      const popup = window.open(url, 'oauth', features.join(','));
      this.openPopup = popup;
      if (!popup) {
         alert('failed to pop up auth window');
      }
      popup.focus();
   }
   waitCallback(): boolean {
      const value = Boolean(localStorage.getItem('access_token_dropbox'));

      return !value && !this.openPopup.closed;
   }

   getCodeReturn(){
      localStorage.setItem('dropbox_auth', this.openPopup.location.search.replace('?code=', ''));
   }

   isCallback(): boolean {
      const value = Boolean(localStorage.getItem('access_token_dropbox'));
      return !value && !this.openPopup.closed;
   }

   clearDropBox() {
      localStorage.removeItem('access_token_dropbox');
      localStorage.removeItem('dropbox_auth');
      localStorage.removeItem('refresh_token_dropbox');
      this.keyAccessToken = '';
      this.refreshAccessToken = '';
   }
}
